import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import { INDUSTRIES } from "@/lib/data";
import { ArrowRight } from "lucide-react";

export default function Industries() {
  return (
    <Layout>
      <section className="py-28 border-b border-white/10" data-testid="industries-hero">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <span className="eyebrow">Industries</span>
          <h1 className="heading-massive mt-4">
            Built for the <span className="text-tratou-green">hard sites.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-tratou-dim text-lg">
            From greenfield construction to remote mines, Tratou MBESS delivers grid-quality power
            with zero emissions, zero noise, and full IoT visibility.
          </p>
        </div>
      </section>

      <section className="py-24" data-testid="industries-grid">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {INDUSTRIES.map(({ label, image, copy, icon: Icon }, i) => (
            <article
              key={label}
              className="relative bg-tratou-deep overflow-hidden group panel-hover"
              data-testid={`industry-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <div className="absolute inset-0">
                <img src={image} alt={label} className="w-full h-full object-cover opacity-30 group-hover:opacity-50 group-hover:scale-110 transition duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-tratou-void via-tratou-void/70 to-transparent" />
              </div>
              <div className="relative p-8 min-h-[340px] flex flex-col justify-end">
                <Icon className="w-7 h-7 text-tratou-green mb-4" />
                <h3 className="font-display text-2xl font-bold">{label}</h3>
                <p className="mt-3 text-tratou-dim text-sm leading-relaxed">{copy}</p>
                <Link
                  to={`/contact?industry=${encodeURIComponent(label)}`}
                  className="mt-5 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-tratou-green hover:gap-3 transition-all"
                  data-testid={`industry-cta-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                >
                  Talk to expert <ArrowRight className="w-3.5 h-3.5" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>
    </Layout>
  );
}
